import { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { AgGridRowResizeDragger } from '../../../containers/commons/AgGrid/components/dragger/rowResizeDragger'
import {
  ProgramManagementRow,
  PROGRAM_MANAGEMENT_ROW_TYPE,
} from '../programManagement'

/**
 * 行のリンク先となるプロジェクト計画画面の URL を返す。
 * - PROJECT 行: /projectPlan/{projectCode}
 * - WORKGROUP/PROCESS 行: /projectPlan/{projectCode}?treeRootUuid={行のprojectPlanUuid}
 * - 上記以外（PROGRAM/GROUP）やプロジェクトコード未解決時は undefined（リンクにしない）
 */
const buildProjectPlanUrl = (
  params: ICellRendererParams<ProgramManagementRow>
): string | undefined => {
  const { data, api } = params
  if (!data) return undefined

  if (data.type === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT) {
    return data.code ? `/projectPlan/${data.code}` : undefined
  }

  if (
    data.type !== PROGRAM_MANAGEMENT_ROW_TYPE.WORKGROUP &&
    data.type !== PROGRAM_MANAGEMENT_ROW_TYPE.PROCESS
  ) {
    return undefined
  }

  // treeValue を末尾（自身に近い側）から辿って祖先の PROJECT 行を解決する
  for (let i = data.treeValue.length - 2; i >= 0; i--) {
    const ancestor = api.getRowNode(data.treeValue[i])?.data
    if (
      ancestor?.type === PROGRAM_MANAGEMENT_ROW_TYPE.PROJECT &&
      ancestor.code
    ) {
      return `/projectPlan/${ancestor.code}?treeRootUuid=${data.uuid}`
    }
  }
  return undefined
}

/**
 * プログラム管理画面の行番号セル。
 * プロジェクト/ワークグループ/工程行はリンクにし、クリックでその行をルートとする
 * プロジェクト計画画面を別タブで開く（ProjectPlanNew の行番号セルと同様の動線）。
 */
export const ProgramManagementSequenceNoCellRenderer = memo(
  (props: ICellRendererParams<ProgramManagementRow>) => {
    const url = buildProjectPlanUrl(props)
    return (
      <div className="sevend-ag-cell-sequence-no">
        {url ? (
          <a
            className="sevend-ag-cell-sequence-no__link"
            onClick={() => window.open(`${window.location.origin}${url}`)}
          >
            {props.value}
          </a>
        ) : (
          <p className="sevend-ag-cell-sequence-no__label">{props.value}</p>
        )}
        {!props.context?.isRowHeightFixed && (
          <AgGridRowResizeDragger node={props.node} api={props.api} />
        )}
      </div>
    )
  },
  (prevProps, nextProps) => {
    if (prevProps.value !== nextProps.value) return false
    if (prevProps.data?.uuid !== nextProps.data?.uuid) return false
    if (prevProps.data?.code !== nextProps.data?.code) return false
    if (
      prevProps.context?.isRowHeightFixed !==
      nextProps.context?.isRowHeightFixed
    ) {
      return false
    }
    return true
  }
)
